






import { Component, Vue, Watch } from 'vue-property-decorator';

@Component({})
export default class App extends Vue {
  private isBlank: boolean = false;
  private mounted() {
    console.log('app mounted');
  }
  @Watch('$route')
  private route_OnChange(val: any, oldVal: any) {
    this.isBlank = val.path.indexOf('/blank/') >= 0;
  }
  private beforeRouteEnter(to: any, from: any, next: any) {
    console.log(to);
  }
}
